import React, { useRef, useState } from 'react';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

// Components
import { Modal, Button } from 'react-bootstrap';
import Receipt from '../Receipt';
import { useReactToPrint } from 'react-to-print';

const ReceiptModal = (props) => {
    const [signature, setSignature] = useState(false);
    const orderRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => orderRef.current,
    });

    const printWithSignature = (signature) => {
        setSignature(signature);
        setTimeout(handlePrint, 500);
    }

    return (
        <Modal show={props.show} contentClassName={styles.ReceiptModal} onHide={props.onClose}>
            <div className={styles.Buttons}>
                <Button variant="dark" className={styles.Button} onClick={() => printWithSignature(false)}>
                    <FontAwesomeIcon icon={faPrint} className={styles.Icon} />
                    <span>Printear</span>
                </Button>
                <Button variant="secondary" className={styles.Button} onClick={() => printWithSignature(true)}>
                    <FontAwesomeIcon icon={faPrint} className={styles.Icon} />
                    <span>Printear con Firma</span>
                </Button>
            </div>
            <div ref={orderRef} className={styles.PrintContainer}>
                <Receipt order={props.order} signature={signature} />
            </div>
        </Modal>
    )
};

export default ReceiptModal;